"use client"

import { ADMIN_API_CONFIG } from "@/constants/api-configs"
import { DefaultImage } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"
import Image from "next/image"
import Link from "next/link"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

export interface CycListProps extends CommonStylesProps {
  items?: { icon?: string; title?: string; link?: string }[]
}

export const RenderConfig: ComponentConfig<CycListProps> = {
  render: ({ className, styles, responsiveType, items = [] }) => {
    const id = `cyc-list-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div id={id} className={twMerge(className, "w-full")}>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 sm:gap-6 ">
            {items.map((item, index) => (
              <Link
                href={item.link || "#"}
                key={index}
                className="group w-full h-full cursor-pointer transition-transform duration-300 hover:scale-105 flex flex-col items-center justify-start gap-6 sm:bg-[#FFFFFF14] rounded-2xl sm:py-12 sm:px-8 p-8"
              >
                <div className="sm:w-[95px] sm:h-[105px] w-[72px] h-[80px] relative">
                  <Image
                    src={item.icon ? `${ADMIN_API_CONFIG.API_URL}${item.icon}` : DefaultImage}
                    alt={`${item.title} Icon`}
                    fill
                    className="object-contain"
                  />
                </div>

                {item.title && (
                  <h3 className="sm:text-xl sm:leading-[30px] text-base leading-[27px] text-center text-white font-normal group-hover:text-[#e1e1e1] transition-all duration-300">
                    {item.title}
                  </h3>
                )}
              </Link>
            ))}
          </div>
        </div>
      </>
    )
  },
}
